import React from "react";
import "./customTable.css";
import commoncss from "../../../myfin_v2/css/common.module.css";

const MERGE_KEYS = ["date", "particular"];

const isPrimitive = (v) =>
  v === null || ["string", "number", "boolean"].includes(typeof v);

const buildRowSpanMap = (rows, mergeKeys) => {
  const spanMap = {};
  let i = 0;

  while (i < rows.length) {
    let span = 1;

    for (
      let j = i + 1;
      j < rows.length && mergeKeys.every((k) => rows[j][k] === rows[i][k]);
      j++
    ) {
      span++;
    }

    mergeKeys.forEach((key) => {
      spanMap[`${i}-${key}`] = span;
      for (let k = i + 1; k < i + span; k++) {
        spanMap[`${k}-${key}`] = 0;
      }
    });

    i += span;
  }

  return spanMap;
};

const ConsoleTable = ({ tableData, tableTitle = null, type }) => {
  if (!tableData?.length) return null;

  const simpleColumns = Object.keys(tableData[0]).filter(
    (key) =>
      !key.startsWith("_") &&
      key !== "companies" &&
      key !== "lineType" && 
      key !== "currentYear" &&     
      key !== "previousYear" && 
      
      // hide lineType column
      isPrimitive(tableData[0][key])
  );

  const companies = tableData[0].companies || [];

  const periods = Array.from(
    new Set(
      companies.flatMap((company) =>
        Object.keys(company).filter((k) => k !== "title" && !k.startsWith("_"))
      )
    )
  );

  const rowSpanMap = buildRowSpanMap(tableData, MERGE_KEYS);

  return (
    <>
    <div className="table-outer" style={{ width: "100%" }}>
      {tableTitle && (
        // <span
        //   className={`${commoncss.fs22} ${commoncss.fw500} ml-2`}
        //   style={{
        //     width: "fit-content",
        //     display: "flex",
        //     justifyContent: "space-between",
        //     // marginBottom:"-5px"
        //     paddingLeft: "3px",
        //    }}
        // >
        //   {tableTitle}
        // </span>

        <div className="table-title-wrapper">
        <span
          className={`table-title ${commoncss.fs22} ${commoncss.fw500}`}
        >
          {tableTitle}
        </span>
      </div>
      )}
      <div className="table-container1" style={{ width: "100%", overflowX: "auto" }} >
        <table className="financial-table" style={{ width: "100%", minWidth: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              {simpleColumns.map((col) => (
                <th key={col} rowSpan={2} className={`col-text ${ col === "particular" ? "particular-heading tableHeadingColor" : "" }`} >
                  {col.toUpperCase()}
                </th>
              ))}

              {companies.map((company, idx) => (
                <th key={idx} className="col-group tableHeadingColor" colSpan={periods.length}>
                  {company.title}
                </th>
              ))}
            </tr>

            <tr>
              {companies.map(() =>
                periods.map((p) => (
                  <th key={p} className="col-number tableHeadingColor">
                    {p}
                  </th>
                ))
              )}
            </tr>
          </thead>

          <tbody>
            {tableData.map((row, rowIndex) => {
              const isHeader = row.lineType === "header";

              return (
                <tr
                  key={row._id || rowIndex}
                  className={isHeader ? "row-header" : ""}
                >
                  {simpleColumns.map((col) => {
                    if (MERGE_KEYS.includes(col)) {
                      const span = rowSpanMap[`${rowIndex}-${col}`];
                      if (span === 0) return null;

                      return (
                        <td
                          key={col}
                          rowSpan={span}
                          className={`col-text ${
                            isHeader ? "header-cell" : ""
                          }`}
                        >
                          {row[col]}
                        </td>
                      );
                    }

                    return (
                      <td
                        key={col}
                        className={`col-text ${isHeader ? "header-cell" : ""}`}
                      >
                        {row[col]}
                      </td>
                    );
                  })}

                  {row.companies.map((company, cIdx) =>
                    periods.map((period) => (
                     <td
                        key={`${rowIndex}-${cIdx}-${period}`}
                        className={`col-number ${isHeader ? "header-cell" : ""}`}
                      >
                        {company[period] !== null && company[period] !== undefined
                          ? (Number(company[period]) < 0
                              ? `(${Math.abs(Number(company[period])).toLocaleString("en-IN")})`
                              : Number(company[period]).toLocaleString("en-IN"))
                          : ""}
                      </td>
                    ))
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
       </div>
      </div>
    </>
  );
};

export default ConsoleTable;
